import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AppStateService {

  constructor() { }

  private _sizeUnits: string = 'imperial'; // 'metric' or 'imperial'
  sizeunitsChange: Subject<string> = new Subject<string>();

  public get sizeUnits(): string {
    return this._sizeUnits;
  }
  public set sizeUnits(value: string) {
    this.sizeunitsChange.next(value);
    this._sizeUnits = value;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/app-state.service.ts